import Formsy, { withFormsy } from "UNSAFE_formsy-react";

const HOC = withFormsy;

export default Formsy;
export * from "UNSAFE_formsy-react";
export { HOC };
